<!-- =========================================================================================
  File Name: UserView.vue
  Description: User View page

========================================================================================== -->

<template>
  <div id="page-set-view">

    <vs-alert v-if="errorOccurred" color="danger" title="Set Not Found">
      <span>Set record with id:  not found. </span>
      <span>
        <span>Check </span><router-link :to="{name:'admin-list-flashcard-set'}"
                                        class="text-inherit underline">All Sets</router-link>
      </span>
    </vs-alert>

    <div v-if="setData" id="set-data">

      <!--- TOP SET BANNER START --->
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <div class="rounded-lg w-full"
               style="background-image: url(https://cdn.discordapp.com/attachments/733851758211629347/954057924391600218/BG.png);
               box-shadow: 0px 4px 25px 0px rgba(0,0,0,.1);">
            <div class="knowledge-base-jumbotron-content rounded-lg lg:p-12 sm:p-10 p-8" style="backdrop-filter: blur(10px)">
              <div class="flex gap-6 items-center ">
                <img class="rounded" :src="setData.thumbnail" v-if="setData.thumbnail" width="150px">
                <div>
                  <h5 class="font-light text-white ml-2 ">FlashCards Admin</h5>
                  <h1 class="text-white font-bold" style="font-size: 4rem">{{ setData.name }}</h1>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--- TOP SET BANNER END --->


      <!--- SET ACTION BAR START --->
      <div class="vx-row mb-6 match-height">
        <div class="vx-col grid grid-cols-3 gap-8 w-full">
          <vx-card class=" p-6 cursor-pointer" @click="$router.push(`/a/flashcards/`)"
                   :style="`background-image: linear-gradient(118deg, rgba(var(--vs-primary), 0.4), rgba(var(--vs-primary), .2)), url(${cardBgImgURL})`">
            <div class="flex items-center justify-center">
              <feather-icon icon="ArrowLeftCircleIcon" svgClasses="h-16 w-16"/>
            </div>
            <div class="flex items-center justify-center">
              <h2 class="text-center mt-4 text-white">Back To<br>FlashCard Manager</h2>
            </div>
          </vx-card>
          <vx-card class=" p-6 cursor-pointer" @click="$router.push(`/a/flashcards/sets/${setData.id}/edit`)"
                   :style="`background-image: linear-gradient(118deg, rgba(var(--vs-success), 0.4), rgba(var(--vs-success), .2)), url(${cardBgImgURL})`">
            <div class="flex items-center justify-center">
              <feather-icon icon="EditIcon" svgClasses="h-16 w-16"/>
            </div>
            <div class="flex items-center justify-center">
              <h2 class="text-center mt-4 text-white">Edit<br>Set</h2>
            </div>
          </vx-card>
          <vx-card class="p-6 cursor-pointer text-white" @click="confirmDeleteSet"
                   :style="`background-image: linear-gradient(118deg, rgba(var(--vs-danger), 0.4), rgba(var(--vs-danger), .2)), url(${cardBgImgURL})`">
            <div class="flex items-center justify-center">
              <feather-icon icon="TrashIcon" svgClasses="h-16 w-16"/>
            </div>
            <div class="flex items-center justify-center">
              <h2 class="text-center mt-4 text-white">Archive<br>Set</h2>
            </div>
          </vx-card>
        </div>
      </div>
      <!--- SET ACTION BAR END --->

      <!--- SET SHOW INFORMATION START--->
      <div class="vx-row mb-6 match-height">
        <div class="vx-col w-1/3">
          <vx-card class="w-full flex items-center">
            <h3 class="font-bold">Set Id</h3>
            <h3 class="font-light">{{ setData.id }}</h3>
          </vx-card>
        </div>
        <div class="vx-col w-1/3">
          <vx-card class="w-full flex items-center">
            <h3 class="font-bold">Set Status</h3>
            <h3 class="capitalize font-light">{{ setData.status }}</h3>
          </vx-card>
        </div>
        <div class="vx-col w-1/3">
          <vx-card class="w-full flex items-center">
            <h3 class="font-bold">Set Terms</h3>
            <h3 class="capitalize font-light">{{ setData.terms.length }}</h3>
          </vx-card>
        </div>
      </div>
      <!--- SET SHOW INFORMATION END--->

      <!--- SET TERM ACTIONS START --->
      <div class="vx-row mb-6 match-height">
        <div class="vx-col w-1/3">
          <vx-card>
            <vs-button color="success" type="gradient" class="w-full" icon-pack="feather" icon="icon-plus"
                       @click="createTermPopup = true">Create Term
            </vs-button>
          </vx-card>
        </div>
        <div class="vx-col w-1/3">
          <vx-card>
            <vs-button color="warning" type="gradient" class="w-full" icon-pack="feather" icon="icon-file-plus"
                       @click="addTermPopup = true">Add Existing Term
            </vs-button>
          </vx-card>
        </div>
        <div class="vx-col w-1/3">
          <vx-card>
            <vs-button color="primary" type="gradient" class="w-full" icon-pack="feather" icon="icon-upload"
                       @click="$router.push(`/a/flashcards/terms/upload?sets=${JSON.stringify([setData.id])}`)">Upload Terms
            </vs-button>
          </vx-card>
        </div>


      </div>
      <!--- SET TERM ACTIONS END --->

      <!--- SET TERMS START --->
      <div class="vx-row">
        <div class="vx-col w-full">
          <list-terms title="Set Terms" :set-id="setData.id" :filter-sets="false" :filter-button="false" :key="termTableKey" v-on:refresh_data="fetchSetDetails(setData.id)"/>
        </div>
      </div>
      <!--- SET TERMS END --->

      <!--- CREATE TERM START --->
      <vs-popup :active.sync="createTermPopup" title="Create Term Values" id="CreateTermPopup">
        <vs-input v-model="createTermDetails.term" class="mb-8 w-full" label-placeholder="Term"/>
        <!--- <vs-input v-model="createTermDetails.term_extended" class="mb-8 w-full"
                   label-placeholder="Term Extended"/> --->
         <vs-input v-model="createTermDetails.term_image" class="mb-8 w-full" label-placeholder="Term Image"/>

         <vs-input v-model="createTermDetails.definition" class="mb-8 w-full" label-placeholder="Definition"/>
         <!--- <vs-input v-model="createTermDetails.definition_extended" class="mb-8 w-full"
                   label-placeholder="Definition Extended"/> --->
        <vs-input v-model="createTermDetails.definition_image" class="mb-6 w-full" label-placeholder="Definition Image"/>
        <vs-button color="success" type="filled" @click="createTerm">Create Term</vs-button>
      </vs-popup>
      <!--- CREATE TERM END --->

      <!--- ADD TERM START --->
      <vs-popup :active.sync="addTermPopup" title="Search for Term">

        <vs-table :data="addTermResults" :sst="true" max-items="5" search
                  @search="addTermSearch">
          <template slot="header">
            <h3 class="ml-4">Term Bank</h3>
          </template>

          <template slot="thead">
            <vs-th>Term</vs-th>
            <vs-th>Definition</vs-th>
            <vs-th>Action</vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr v-for="(attach) in data" :key="attach.id">

              <vs-td :data="attach.term">
                {{ attach.term }}
              </vs-td>

              <vs-td :data="attach.definition">
                {{ attach.definition }}
              </vs-td>


              <vs-td>
                <vs-button color="primary" size="small" type="border" @click="addTermToSet(attach.id)">
                  Assign
                </vs-button>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </vs-popup>
      <!--- ADD TERM END --->


    </div>
    <div class="simple-spinner" v-else>
      <span></span>
    </div>

  </div>
</template>

<script>
import Prism from 'vue-prism-component'
import vSelect from 'vue-select'
import ListTerms from '../../terms/term-list/ListTerms'

export default {
  data () {
    return {
      cardBgImgURL: 'https://media.discordapp.net/attachments/733851758211629347/954057924630700132/BG2.png?width=1352&height=676',

      setData: null,
      setPracticeData: null,
      setDescriptionCounter: false,
      errorOccurred: false,

      createTermPopup: false,
      createTermDetails: {term: null, term_extended: null, term_image: null, definition: null, definition_extended: null, definition_image: null},

      addTermPopup: false,
      addTermResults: '',


      termTableKey: 0

    }
  },
  components: {
    Prism,
    vSelect,
    ListTerms
  },
  methods: {
    fetchSetDetails (id) {
      this.$http.get(`flashcards/sets/${id}`)
        .then(response => {
          if (response.status === 200) {
            this.setData = response.data.data
          }
        })
        .catch(error => {
          this.errorOccurred = true
          this.error_msg = error
        })
    },
    confirmDeleteSet () {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Archive',
        text: 'Please confirm you want to archive this set.',
        accept: this.deleteSet,
        acceptText: 'Archive'
      })
    },
    addTermSearch (term) {
      this.$http.get(`flashcards/terms?search=${term}&amount=3`)
        .then(response => {
          if (response.data) {
            this.addTermResults = response.data.data
          }
        })
    },
    addTermToSet (id) {
      if (this.setData.terms.includes(id)) return this.handleError('', 'Term is already inside of set', 'You cannot add a term into a set twice')
      this.$vs.loading()
      this.$http.post(`flashcards/sets/${this.setData.id}/terms`, [id])
        .then(response => {
          if (response.status === 200) {
            this.termTableKey++
            this.fetchSetDetails(this.setData.id)
            this.$vs.loading.close()
          }
        })
        .catch(exception => {
          this.$vs.loading.close()
          this.handleError(exception, 'Failed to add term to set')
        })
    },
    createTerm () {
      this.$vs.loading()
      this.$http.post('flashcards/questions/create', this.createTermDetails)
        .then(response => {
          if (response.status === 200) {
            this.$vs.loading.close()
            this.$vs.notify({
              title: 'Created set successfully',
              text: 'New term has been created.',
              color: 'success',
              position: 'top-right'
            })
            this.addTermToSet(response.data.data.id)
            this.createTermDetails = {term: '', term_extended: '', term_image: '', definition: '', definition_extended: '', definition_image: ''}
          }
        })
        .catch(exception => {
          this.$vs.loading.close()
          this.handleError(exception, 'Failed to create term')
        })
    },
    deleteSet () {
      this.$vs.loading()

      this.$http.delete(`flashcards/sets/${this.$route.params.setId}`)
        .then(response => {
          this.$vs.loading.close()

          if (response.status === 200) {
            this.$router.push('/a/flashcards/sets')

            return this.$vs.notify({
              color: 'success',
              title: 'Set Archived',
              text: 'You have successfully archived this set',
              icon: 'feather',
              iconPack: 'icon-check-circle',
              position: 'top-right'
            })
          }
        })
        .catch(exception => {
          this.$vs.loading.close()
          this.handleError(exception, 'Failed to archive set')

        })
    },
    refreshSetCache (id) {
      this.$vs.loading()

      this.$http.get(`flashcards/sets/${id}/cache`)
        .then(response => {
          this.$vs.loading.close()

          if (response.status === 200) {
            return this.$vs.notify({
              color: 'success',
              title: 'Cache Cleared',
              text: 'The set cache has been cleared successfully',
              icon: 'feather',
              iconPack: 'icon-check-circle',
              position: 'top-right'
            })
          }

        })
        .catch(exception => {
          this.$vs.loading.close()
          this.handleError(exception, 'Failed to Clear Cache')
        })
    },
    handleError (exception, title, text) {
      let error = 'An unknown error occurred while adding term to set'
      if (exception.response) {
        error = exception.response.data.error.description
      }
      if (text) {
        error = text
      }
      return this.$vs.notify({
        title,
        text: error,
        color: 'danger',
        position: 'top-right'
      })
    }
  },
  created () {
    this.fetchSetDetails(this.$route.params.setId)
    this.addTermSearch('')
  }
}

</script>

<style lang="scss">


.theme-dusk {
  #CreateTermPopup {
    input.vs-inputx.vs-input--input {
      background: #050056 !important;
      border: 1px solid #ffffff !important;

      &:focus {
        border: 1px solid rgba(var(--vs-primary), 1) !important;
      }
    }
  }
}

.theme-dark {
  #CreateTermPopup {
    input.vs-inputx.vs-input--input {
      background: #1B1E22 !important;
      border: 1px solid #ffffff !important;

      &:focus {
        border: 1px solid rgba(var(--vs-primary), 1) !important;
      }
    }
  }
}

#avatar-col {
  width: 10rem;
}

#page-set-view {

  table {
    td {
      vertical-align: top;
      min-width: 140px;
      padding-bottom: .8rem;
      word-break: break-all;
    }

    &:not(.permissions-table) {
      td {
        @media screen and (max-width: 370px) {
          display: block;
        }
      }
    }
  }

  @media (min-width: 1200px) and (max-width: 1700px) {
    .image-set {
      display: none;
    }
    .set-col {
      width: 0 !important;
      min-height: 2.05vh;
    }
    .welcome-col {
      width: 100% !important;
    }
  }
}

</style>
